// extracted by mini-css-extract-plugin
export default {"contentBox":"projectsTabs_contentBox__QObff","tabPanel":"projectsTabs_tabPanel__UYS2s","project-grid":"projectsTabs_project-grid__91Hi7"};